// export const host = 'http://localhost:4000';
export const host = '/api';
// export const host = 'http://192.16.222.8:4000';
// export const host = 'https://hosting-bek.onrender.com';
export const token = localStorage.getItem('token');